import LoginPanel from '@tencent/vft-component/LoginPanel'
console && console.warn('登录组件已迁移至@tencent/vft-component/LoginPanel，请切换至新的组件库')
export default LoginPanel
